module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/sepa-direct-debit-de-3bde59dd652dca02786d07d45d197bc5.svg";